import PageLayout from "../../layouts/PageLayout"
import HeroHeader from "../../components/HeroHeader"
import Background from "../../assets/Background.jpg"
import FleetPage from "./components/FleetPage"

const Fleet = () => (
    <PageLayout
        hero={
            <HeroHeader
                background={Background}
                backgroundPosition="center"
                maxWidth={680}
                overline="Private Hire hire"
                title="Available vehicles"
                subtitle="Licensed cars available on weekly hire across Newcastle and the North East. Enquire on any vehicle and we'll help you arrange collection from our Blaydon office."
                cta={{
                    label: "Browse vehicles",
                    onClick: () =>
                        document.getElementById("vehicles-list")?.scrollIntoView({ behavior: "smooth" }),
                }}
            />
        }
    >
        <FleetPage />
    </PageLayout>
)

export default Fleet
